import { useAuthStore } from '@/store/auth'
import { useAlertStore } from '@/store/alert'
import { facebookLogin, facebookRegister } from '@/service/login'
import { RegistrationType } from '@/types/member'
import { QueryStringKeys } from '@/constants/commons'
import { toSafeInternalUrl } from '@/utils/common'
import type { SocialLoginProvider } from '@/types/socialLogin'

export function createFacebookProvider(): SocialLoginProvider {
  const authStore = useAuthStore()
  const alertStore = useAlertStore()
  const router = useLocaleRouter()
  const { t } = useI18n()

  return {
    type: 'facebook',
    registrationType: RegistrationType.FACEBOOK,
    login: ctx => facebookLogin(ctx.token),
    register: (ctx, param) => facebookRegister(ctx.token, param),
    resolveRedirectUrl: ctx => toSafeInternalUrl(ctx.redirectUrl || ctx.fallbackUrl) ?? '/',
    onUnregistered: () => {
      authStore.openLoginModal()
    },
    onError: (ctx, error: any) => {
      console.error('facebookProvider: error', error)
      alertStore.error(error?.data?.message || t('member_auth_login_failed'))

      const safeFallback = toSafeInternalUrl(ctx.fallbackUrl) ?? '/'
      const url = new URL(safeFallback, location.origin)
      if (ctx.redirectUrl) {
        const safeRedirect = toSafeInternalUrl(ctx.redirectUrl)
        if (safeRedirect) {
          url.searchParams.set(QueryStringKeys.REDIRECT_URL, safeRedirect)
        }
      }
      router.replace(url.pathname + url.search)
    },
  }
}
